import React from 'react';

import moment from 'moment';

import Table from '../../../../../Table';

export default function DocumentsTable({
  rows,
  refetchDocuments,
  readOnly,
  isLender,
  lenderId,
}) {
  const cols = [
    {
      title: 'Date',
      keys: ['date'],
      format: (value) => (value ? moment(value).format('M/D/YY') : ''),
    },
    {
      title: 'Type',
      keys: ['private_document.type'],
    },
    {
      title: 'Name',
      keys: ['private_document.name'],
      format: (value) => {
        if (!value) {
          return 'N/A';
        }

        return value.endsWith('.pdf') ? value : `${value}.pdf`;
      },
    },
    {
      title: 'Description',
      keys: ['description'],
      wrapText: true,
    },
    {
      title: 'Actions',
      type: 'documentActions',
      keys: [],
      refetch: refetchDocuments,
      readOnly,
      isLender,
      lenderId,
    },
  ];

  const sortedRows = rows?.sort((a, b) => {
    return a?.private_document?.type?.localeCompare(b?.private_document?.type);
  });

  return (
    <Table title="Documents" cols={cols} rows={sortedRows} minHeight={200} />
  );
}
